


















import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ListMixin } from '@/mixins/list.mixin'
import { Column } from 'ant-design-vue/types/table/column'
import Filters from '@/components/filters/Filters.vue'
import { Filter, FilterTypes } from '@/interfaces/filter'

@Component({
  components: {
    Filters
  }
})
export default class FormsView extends mixins(ListMixin) implements ListMixin {
  apiConfig = {
    path: 'forms'
  }

  filters: Filter[] = [
    {
      name: 'externalId',
      type: FilterTypes.INPUT,
      input: {
        placeholder: 'External ID'
      }
    },
    {
      name: 'course.externalId',
      type: FilterTypes.INPUT,
      input: {
        placeholder: 'External ID курса'
      }
    },
    {
      name: 'course.site',
      condition: '$cont',
      type: FilterTypes.INPUT,
      input: {
        placeholder: 'Сайт'
      }
    },
    {
      name: 'active',
      type: FilterTypes.CHECKBOX,
      label: {
        text: 'Только активные'
      }
    }
  ]

  columns: Partial<Column>[] = [
    {
      dataIndex: 'externalId',
      title: 'External ID формы',
      scopedSlots: {
        customRender: 'externalId'
      }
    },
    {
      dataIndex: 'course.externalId',
      title: 'External ID курса',
      scopedSlots: {
        customRender: 'course.externalId'
      }
    },
    {
      dataIndex: 'course.name',
      title: 'Название курса',
      scopedSlots: {
        customRender: 'course.name'
      }
    },
    {
      dataIndex: 'course.site',
      title: 'Сайт'
    }
  ]

  customRow(record) {
    return {
      on: {
        dblclick: () => {
          // this.$router.push(`/forms/${record.id}`)
        }
      }
    }
  }
}
